import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpersService } from '@/shared/services/helpers.service';
import { finalize } from 'rxjs';
import { SkeletonModule } from 'primeng/skeleton';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CardComponent } from '@/shared/ui-components/card/card.component';
import { CurrencyDisplayComponent } from '@/shared/ui-components/currency-display/currency-display.component';
import { RouterModule } from '@angular/router';
import { ClientDealsSummaryData, DealsApiService } from '@/pages/deals/data-access/deals-api.service';

@Component({
    standalone: true,
    selector: 'app-c-stats-widget',
    imports: [CommonModule, SkeletonModule, TranslateModule, AngularSvgIconModule, CardComponent, CurrencyDisplayComponent, RouterModule],
    templateUrl: './c-statswidget.html'
})
export class CStatsWidget implements OnInit {
    public summaryData = signal<ClientDealsSummaryData | null>(null);
    public summaryLoading = signal<boolean>(false);

    private readonly _dealsApiService = inject(DealsApiService);
    private readonly _helperService = inject(HelpersService);

    public ngOnInit(): void {
        this.getSummary();
    }

    private getSummary(): void {
        this.summaryLoading.set(true);
        this._dealsApiService
            .getClientDealsSummary()
            .pipe(finalize(() => this.summaryLoading.set(false)))
            .subscribe({
                next: (res) => {
                    this.summaryData.set(res);
                },
                error: (err) => {
                    this._helperService.showErrorMessage(err);
                }
            });
    }
}
